//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VueFinalModal } from 'vue-final-modal'
import { classArray } from '../../utils/class'
import { DTModalHeaderInjector } from '../../keys'
export default {
  components: { VueFinalModal },
  provide() {
    return {
      [DTModalHeaderInjector]: {
        close: this.closeModal,
      },
    }
  },
  props: {
    containerClass: {
      type: [String, Array, Object],
      default: null,
    },
    dialogClass: {
      type: [String, Array, Object],
      default: null,
    },
    overlayClass: {
      type: [String, Array, Object],
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
      validator: (x) => ['xs', 'sm', 'md', 'lg', 'xl', 'fs'].includes(x),
    },
    attach: {
      type: String,
      default: 'body',
    },
    zIndexBase: {
      type: [String, Number],
      default: 1040,
    },
  },
  data() {
    return {
      open: this.value,
    }
  },
  computed: {
    modalClass() {
      return this.attach === 'body' ? ['!tw-fixed'] : []
    },
    vfmClasses() {
      // 5rem space at the bottom is for Intercom launcher
      return classArray(this.containerClass).concat([
        'tw-flex tw-justify-center tw-items-center tw-p-2 !tw-bottom-[5rem]',
      ])
    },
    vfmOverlayClass() {
      return classArray(this.overlayClass).concat(['tw-bg-black/5'])
    },
    vfmContentClass() {
      const sizeClass = {
        xs: 'tw-w-[264px]',
        sm: 'tw-w-[420px]',
        md: 'tw-w-[568px]',
        lg: 'tw-w-[800px]',
        xl: 'tw-w-[960px]',
        fs: 'tw-w-screen tw-max-w-7xl',
      }[this.size]
      return classArray(this.dialogClass).concat([
        sizeClass,
        'tw-font-sans tw-flex tw-flex-col tw-max-h-full tw-mx-2 tw-my-2 md:tw-my-4 md:tw-mx-4 tw-p-4 md:tw-p-6 tw-rounded-xl tw-bg-white tw-drop-shadow-2xl tw-overflow-hidden',
      ])
    },
  },
  watch: {
    value: {
      handler(val) {
        this.open = val
      },
    },
  },
  methods: {
    closeModal() {
      this.open = false
      this.$emit('input', false)
    },
  },
}
